var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0909 5.27255C13.0909 2.458 10.8145 0.181641 8 0.181641C5.65818 0.181641 3.68727 1.76709 3.09818 3.92709C1.32364 4.33437 0 5.91982 0 7.818C0 10.0289 1.78909 11.818 4 11.818C5.28 11.818 11.4545 11.818 12.7273 11.818C14.5382 11.8107 16 10.3416 16 8.53073C16 6.83619 14.7273 5.46164 13.0909 5.27255ZM8.72727 6.7271V8.18164C8.72727 8.58164 8.4 8.90891 8 8.90891C7.6 8.90891 7.27273 8.58164 7.27273 8.18164V6.7271H5.97091C5.64364 6.7271 5.48364 6.33437 5.71636 6.10891L7.74545 4.07982C7.89091 3.93437 8.11636 3.93437 8.26182 4.07982L10.2909 6.10891C10.5164 6.33437 10.3564 6.7271 10.0364 6.7271H8.72727Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackup);
export default __webpack_public_path__ + "static/media/backup.5b5e3824840807651294966a7ee6022a.svg";
export { ForwardRef as ReactComponent };